(function () {
  const container = document.getElementById('ArticlesPagesResults');
  if (!container) return;

  const terms = container.getAttribute('data-search-terms');
  if (!terms) return;

  const columnsDesktop = container.getAttribute('data-columns-desktop') || '';
  const columnsMobile = container.getAttribute('data-columns-mobile') || '';
  const articleImageRatio = container.getAttribute('data-article-image-ratio') || 'square';

  const sectionId = 'novicell_search-articles-pages';
  const url = `/search?q=${encodeURIComponent(terms)}&type=article,page&section_id=${sectionId}`;

  fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
    .then((response) => {
      if (!response.ok) throw new Error(`Search section fetch failed: ${response.status}`);
      return response.text();
    })
    .then((html) => {
      const tmp = document.createElement('div');
      tmp.innerHTML = html.trim();
      const rendered = tmp.querySelector('.search-results-articles-pages');
      if (!rendered) return;

      const articlesCount = parseInt(rendered.getAttribute('data-articles-count'), 10) || 0;
      const pagesCount = parseInt(rendered.getAttribute('data-pages-count'), 10) || 0;

      container.innerHTML = '';
      container.appendChild(rendered);

      applyGridColumns(rendered);
      applyArticleAspectRatio(rendered);
      updateTabs(articlesCount, pagesCount);
      hideNoResultsIfNeeded(articlesCount, pagesCount);
    })
    .catch((err) => {
      console.warn('[search] Failed to load articles & pages:', err);
    });

  function applyGridColumns(rendered) {
    const desktopMatch = columnsDesktop.match(/cols-(\d+)/);
    const desktopUnits = desktopMatch ? parseInt(desktopMatch[1], 10) : 6;
    const desktopCols = desktopUnits === 8 ? 4 : 3;

    const mobileMatch = columnsMobile.match(/cols-(\d+)/);
    const mobileCols = mobileMatch ? parseInt(mobileMatch[1], 10) : 1;

    const grids = rendered.querySelectorAll('[data-articles-grid]');
    grids.forEach((grid) => {
      if (columnsDesktop) grid.classList.add(columnsDesktop);
      if (columnsMobile) grid.classList.add(columnsMobile);
      grid.style.setProperty('--cols-desktop', desktopCols);
      grid.style.setProperty('--cols-mobile', mobileCols);
      // Match the visible column count for legacy CSS in novicell_search-articles-pages.liquid
      grid.style.setProperty('--grid-units', desktopCols);
      grid.style.setProperty('--span-standard', 'span 1');
      grid.style.setProperty('--span-double', 'span 1');
    });
  }

  function applyArticleAspectRatio(rendered) {
    if (articleImageRatio === 'square') return;

    const cards = rendered.querySelectorAll('.article-card');
    cards.forEach((card) => {
      let ratioPercent;

      if (articleImageRatio === 'portrait') {
        ratioPercent = '125%';
      } else if (articleImageRatio === 'adapt') {
        const img = card.querySelector('.article-card__image-wrapper img');
        if (!img) return;
        const w = parseFloat(img.getAttribute('width'));
        const h = parseFloat(img.getAttribute('height'));
        if (!w || !h) return;
        ratioPercent = ((h / w) * 100).toFixed(2) + '%';
      }

      if (!ratioPercent) return;

      card.style.setProperty('--ratio-percent', ratioPercent);
      const inner = card.querySelector('.card__inner');
      if (inner) inner.style.setProperty('--ratio-percent', ratioPercent);
    });
  }

  function updateTabs(articlesCount, pagesCount) {
    const articlesTab = document.querySelector('[data-articles-tab]');
    const pagesTab = document.querySelector('[data-pages-tab]');

    if (articlesTab && articlesCount > 0) {
      const countEl = articlesTab.querySelector('[data-articles-count]');
      if (countEl) countEl.textContent = articlesCount;
      articlesTab.hidden = false;
    }

    if (pagesTab && pagesCount > 0) {
      const countEl = pagesTab.querySelector('[data-pages-count]');
      if (countEl) countEl.textContent = pagesCount;
      pagesTab.hidden = false;
    }
  }

  function hideNoResultsIfNeeded(articlesCount, pagesCount) {
    if (articlesCount === 0 && pagesCount === 0) return;
    const noResults = document.querySelector('[data-no-results]');
    if (noResults) noResults.hidden = true;
  }
})();
